import React from 'react';
import { Button } from "rhombus-react";
import { useDispatch } from 'react-redux';

import useAssetUploader from 'hooks/useAssetUploader';
import { openModal } from 'reducers/Modal';
import { MODAL_TYPES, CV, CREATIVE_VIEW } from 'utils/constants';
import BasicAction from 'widgets/ActionMenu/BasicAction';
import Permissioned from 'widgets/Permissioned';

export function UploadImageAction({ isButton }){
	const name = "Upload Images";
	const iconName = "assetImage";

	const selectFiles = useAssetUploader({
		assetType: "image",
		accept: "image/*",
	});

	if(isButton){
		return (
			<Button
				icon = {iconName}
				onClick={selectFiles}
			>
				{name}
			</Button>
		);
	}

	let actionProps = {
		name,
		iconName,
		handleClick: selectFiles,
	};

	return (
		<BasicAction {...actionProps} />
	);
}

export function UploadVideoAction({ isButton }){
	const name = "Upload Videos";
	const iconName = "assetVideo";

	const selectFiles = useAssetUploader({
		assetType: "video",
		accept: ".mp4,.mov,.flv,.mpeg,.mpg,.avi,.wmv",
	});

	if(isButton){
		return (
			<Button
				icon = {iconName}
				onClick={selectFiles}
			>
				{name}
			</Button>
		);
	}

	let actionProps = {
		name,
		iconName,
		handleClick: selectFiles,
	};

	return (
		<BasicAction {...actionProps} />
	);
}



export function UploadAudioAction({ isButton }){
	const name = "Upload Audio";
	const iconName = "fas fa-volume"; // TODO: Update to assetAudio after RRACT-168 is merged in

	const selectFiles = useAssetUploader({
		assetType: "audio",
		accept: ".ogg,.mp3,.m4a,.aac,.wav",
	});

	if(isButton){
		return (
			<Button
				icon = {iconName}
				onClick={selectFiles}
			>
				{name}
			</Button>
		);
	}

	let actionProps = {
		name,
		iconName,
		handleClick: selectFiles,
	};

	return (
		<BasicAction {...actionProps} />
	);
}

export function UploadRichloadAction({ isButton }){
	const name = "Upload Richloads";
	const iconName = "assetRichload";

	const selectFiles = useAssetUploader({
		assetType: "richload",
		accept: ".zip",
	});

	if(isButton){
		return (
			<Button
				icon = {iconName}
				onClick={selectFiles}
			>
				{name}
			</Button>
		);
	}

	let actionProps = {
		name,
		iconName,
		handleClick: selectFiles,
	};

	return (
		<BasicAction {...actionProps} />
	);
}

export function UploadTextAction({ isButton }) {
	const name = "Upload Text";
	const iconName = "assetText";

	const dispatch = useDispatch();

	const openUploadTextModal = (e) => {
		e.preventDefault();

		dispatch(openModal(MODAL_TYPES.UPLOAD_TEXT_ASSET));
	};

	if (isButton) {
		return (
			<Button
				icon = {iconName}
				onClick = {openUploadTextModal}
			>
				{name}
			</Button>
		);
	}

	let actionProps = {
		name,
		iconName,
		handleClick: openUploadTextModal,
	};

	return (
		<BasicAction {...actionProps} />
	);
}

export function UploadAfterEffects({ isButton }){
	const name = "Upload After Effects Package (.zip)";
	const iconName = "fas fa-file-zipper";

	const selectFiles = useAssetUploader({
		assetType: "after-effect",
		accept: ".zip",
		multiple: false,
	});

	if(isButton){
		return (
			<Button
				icon = {iconName}
				onClick = {selectFiles}
			>
				{name}
			</Button>
		);
	}

	let actionProps = {
		name,
		iconName,
		handleClick: selectFiles,
	};

	return <BasicAction {...actionProps} />;
}

export function CreateImposiumProject({ isButton }){
	const name = "Create Imposium Project";
	const iconName = "fas fa-paintbrush-pencil";
	const dispatch = useDispatch();

	const openCreateImposiumProjectModal = (e) => {
		e.preventDefault();
		dispatch(openModal(MODAL_TYPES.CREATE_IMPOSIUM_PROJECT));
	};

	let actionProps = {
		name,
		iconName,
		handleClick: openCreateImposiumProjectModal,
	};

	let action = <BasicAction {...actionProps} />;
	if (isButton) {
		action = (
			<Button
				icon={iconName}
				onClick={openCreateImposiumProjectModal}
			>
				{name}
			</Button>
		);
	}

	return (
		<Permissioned domain={CV} action={CREATIVE_VIEW.UPLOAD_VAST}>
			{action}
		</Permissioned>
	);
}

const createAssetActions = [
	{
		name: "images",
		renderChild: () => <UploadImageAction />,
	},
	{
		name: "richloads",
		renderChild: () => <UploadRichloadAction />,
	},
	{
		name: "videos",
		renderChild: () => <UploadVideoAction />,
	},
	{
		name: "audio",
		renderChild: () => <UploadAudioAction />,
	},
	{
		name: "texts",
		renderChild: () => <UploadTextAction />,
	},
	{
		name: "afterEffectsPackage",
		renderChild: () => <UploadAfterEffects />,
	},
	{
		name: "createImposiumProject",
		renderChild: () => <CreateImposiumProject />,
	}
];

export const createAssetButtons = [
	<UploadImageAction key="images" isButton />,
	<UploadRichloadAction key="richloads" isButton />,
	<UploadVideoAction key="videos" isButton />,
	<UploadAudioAction key="audio" isButton />,
	<UploadTextAction key="text" isButton />,
	<UploadAfterEffects key="afterEffectsPackage" isButton />,
	<CreateImposiumProject key="createImposiumProject" isButton />
];

export default createAssetActions;
